import React from 'react';
export default function CyborgVisorSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="visorGlow" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#00BCD4" />
          <stop offset="50%" stopColor="#00E5FF" />
          <stop offset="100%" stopColor="#00BCD4" />
        </linearGradient>
      </defs>

      {/* Metal frame - outer */}
      <rect x="3" y="14" width="34" height="14" rx="4" fill="#546E7A" />
      {/* Metal frame - inner bevel */}
      <rect x="4" y="15" width="32" height="12" rx="3" fill="#78909C" />

      {/* Cyan visor panel */}
      <rect x="6" y="17" width="28" height="8" rx="2" fill="url(#visorGlow)" />
      <rect x="6" y="17" width="28" height="8" rx="2" fill="white" opacity="0.15" />

      {/* Scan line effect */}
      <rect x="6" y="19" width="28" height="1" fill="white" opacity="0.2" />
      <rect x="6" y="22" width="28" height="0.5" fill="white" opacity="0.15" />

      {/* Side ear pieces */}
      <rect x="0" y="16" width="5" height="10" rx="2" fill="#455A64" />
      <rect x="35" y="16" width="5" height="10" rx="2" fill="#455A64" />

      {/* Small LED dots */}
      <circle cx="3" cy="19" r="1" fill="#00E5FF" opacity="0.9">
        <animate attributeName="opacity" values="0.4;1;0.4" dur="1s" repeatCount="indefinite" />
      </circle>
      <circle cx="37" cy="19" r="1" fill="#00E5FF" opacity="0.9">
        <animate attributeName="opacity" values="0.4;1;0.4" dur="1s" repeatCount="indefinite" />
      </circle>

      {/* Top screws */}
      <circle cx="10" cy="15" r="1" fill="#37474F" />
      <circle cx="30" cy="15" r="1" fill="#37474F" />

      {/* Visor reflection streak */}
      <path d="M8 18 L16 18" stroke="white" strokeWidth="0.8" strokeLinecap="round" opacity="0.4" />
    </svg>
  );
}
